import { useTranslation } from 'react-i18next';
import { EmailLink } from './EmailLink';

interface LegalCompanyBlockProps {
  label?: string;
}

export function LegalCompanyBlock({ label }: LegalCompanyBlockProps) {
  const { t } = useTranslation();
  const detailsClassName = label
    ? 'mt-4 space-y-2 text-gray-700'
    : 'space-y-2 text-gray-700';

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-6">
      {label ? (
        <p className="text-sm font-semibold text-gray-900">{label}</p>
      ) : null}
      <div className={detailsClassName}>
        <p className="font-semibold text-gray-900">{t('legal.company.name')}</p>
        <p>{t('legal.company.addressLine1')}</p>
        <p>{t('legal.company.addressLine2')}</p>
        <p>
          <span className="font-semibold text-gray-900">
            {t('legal.company.taxIdLabel')}
          </span>{' '}
          {t('legal.company.taxId')}
        </p>
        <p>
          <span className="font-semibold text-gray-900">
            {t('legal.company.emailLabel')}
          </span>{' '}
          <EmailLink className="text-teal-600 hover:text-teal-700 underline font-semibold">
            {t('legal.company.email')}
          </EmailLink>
        </p>
      </div>
    </div>
  );
}
